import WoltRepository from "@/repositories/WoltRepository";

const getDefaultState = () => {
  return {
    openingTimes: null,
    isOnline: false
  }
}

export default {
  state: getDefaultState(),
  getters: {
    getOpeningTimes: state => state.openingTimes,
    getIsOnline: state => state.isOnline
  },
  mutations: {
    setFromResponse: (state, responseData) => {
      state.openingTimes = responseData.opening_times;
      state.isOnline = responseData.is_online;
    },
    setIsOnline: (state, online) => {
      state.isOnline = online;
    }
  },
  actions: {
    fetchVenueStatus: ({commit}) => {
      return WoltRepository.venues.getVenueStatus().then(response => {
        commit('setFromResponse', response.data.data);
      });
    },
    setVenueOnline: ({commit}, {onlineStatus, until}) => {
      return WoltRepository.venues.setVenueOnline(onlineStatus, until).then(() => {
        commit('setIsOnline', onlineStatus);
      });
    },
    setVenueOpeningTimes: (context, times) => {
      return WoltRepository.venues.setVenueOpeningTimes(times);
    },
  }
}